import { Box, Button, IconButton, Menu, MenuItem, Paper } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {Cancel, MoreVert} from "@mui/icons-material";
import React, {useContext, useRef, useState} from "react";
import {connect} from "react-redux";
import {IScriptTag} from "./State";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {selectUserId} from "../../redux/selectors/editor";

interface Props
{
    grammar: IScriptTag
    onClickSuggestion: (replacement: string, offset: number, length: number) => void
    onClose: () => void
    onIgnore: (event: React.MouseEvent<HTMLElement>) => void
    project: string
    text: string
    user: string
}

const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        flexDirection: "row",
    },
    suggestions:{
        display: "flex",
        flexDirection: "row",
        maxWidth: 500,
        overflowX: "auto"
    }
}))

function GrammarPopup({grammar, onClickSuggestion, onClose, onIgnore, project, text, user}: Props)
{
    const classes = useStyles();
    const [showMore, setShowMore] = useState(false);
    const {setDictionaryEntry} = useContext(FirebaseContext);
    const moreRef = useRef<HTMLDivElement>(null);
    const handleClickSuggestion = (event: React.MouseEvent<HTMLElement>) =>
    {
        event.stopPropagation();
        onClose();
        onClickSuggestion(event.currentTarget.dataset.suggestion || "", grammar.offset, grammar.length);
    }
    const handleMore = () => setShowMore(! showMore);
    const handleMoreClose = () => setShowMore(false);
    const handleAddSpelling = () => {
        setDictionaryEntry(project, user, word).then(() => {
            onClose();
        });
    };
    const word = text.substr(grammar.offset, grammar.length).trim();

    return (
        <Paper onClick={(event) => event.stopPropagation()}>
            <Box className={classes.container}>
                <Box className={classes.suggestions}>
                    {(grammar.suggestions || []).map((suggestion, index) => (
                        <Button style={{ textTransform: "none" }} key={index} data-suggestion={suggestion.value}
                                onClick={handleClickSuggestion} size="small">{suggestion.value}</Button>
                    ))}
                </Box>
                <IconButton size="small" title="Ignore" onClick={onIgnore}><Cancel/></IconButton>
                <div ref={moreRef}>
                    <IconButton size="small" title="More" onClick={handleMore}><MoreVert/></IconButton>
                </div>
                <Menu
                    anchorEl={moreRef.current} onClose={handleMoreClose} open={showMore}
                    transformOrigin={{horizontal: "left", vertical: "bottom"}}>
                    <MenuItem onClick={handleAddSpelling}>Add to dictionary: <em>{word}</em></MenuItem>
                </Menu>
            </Box>
        </Paper>
    );
}
const mapStateToProps = (store: never) => ({
    user: selectUserId(store)
});

export default connect(mapStateToProps, {
})(GrammarPopup);